import * as React from "react";
import { styled } from "@mui/system";
import MUITextareaAutosize from "@mui/material/TextareaAutosize";
import { TextareaAutosizeProps as TextareaAutosizePropsMUI } from "@mui/material/TextareaAutosize";

export interface TextareaAutosizeProps extends TextareaAutosizePropsMUI {
  error?: boolean;
}

const TextareaAutosizeRoot = styled(MUITextareaAutosize, {
  name: "TextareaAutosize",
  slot: "Root",
  shouldForwardProp: (prop) => prop !== "error",
  overridesResolver: (props, styles) => []
})<{ error?: boolean }>(({ theme, error }) => {
  const commonStyles = {
    outline: "none",
    WebkitAppearance: "none",
    width: "-webkit-fill-available",
    // minHeight: 50,
    paddingLeft: 8,
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: 8,
    resize: "vertical",
    ":disabled": {
      cursor: "not-allowed !important",
      pointerEvents: "all !important",
      color: theme.palette.primary.textDisabledColor,
      borderColor: theme.palette.primary.borderDisabled,
      background: theme.palette.primary.inputBackgroundDisabledColor
    },
    ":required": {
      background: theme.palette.primary.inputBackgroundCritical,
      borderColor: theme.palette.primary.borderError
    }
  };
  switch (theme.name) {
    case "fic":
      return {
        "&:active,&:focus": {
          border: error
            ? `2px solid ${theme.palette.primary.borderError}`
            : `2px solid ${theme.palette.primary.borderActive}`,
          background: error
            ? theme.palette.primary.inputBackgroundCritical
            : theme.palette.primary.inputBackgroundActive,
          ":disabled": {
            border: `1px solid ${theme.palette.primary.borderDisabled}`
          }
        },
        ...theme.typography["bodySmall"],
        borderColor: error
          ? theme.palette.primary.borderError
          : theme.palette.primary.borderDefault,
        background: error
          ? theme.palette.primary.inputBackgroundCritical
          : theme.palette.primary.inputBackgroundDefault,
        borderRadius: 4,
        ":read-only": {
          color: theme.palette.primary.textDefaultColor,
          borderColor: theme.palette.primary.borderDisabled,
          background: theme.palette.primary.inputBackgroundReadonlyColor
        },
        ":placeholder": {
          color: theme.palette.primary.textHintColor
        },
        "&:hover": {
          borderColor: error
            ? theme.palette.primary.borderError
            : theme.palette.primary.borderHover,
          background: error
            ? theme.palette.primary.inputBackgroundCritical
            : theme.palette.primary.inputBackgroundActive
        },
        ...commonStyles
      };
    default:
      return {
        ...theme.typography["body"],
        borderColor: theme.palette.primary.borderDefault,
        background: theme.palette.primary.inputBackgroundDefault,
        borderRadius: 0,
        ":focus": {
          background: theme.palette.primary.inputBackgroundActive,
          borderColor: theme.palette.primary.borderActive
        },
        ":read-only": {
          borderColor: theme.palette.primary.borderDisabled,
          background: theme.palette.primary.inputBackgroundDisabledColor
        },
        ":placeholder": {
          color: theme.palette.primary.textDisabledColor
        },
        ":hover": {
          borderColor: theme.palette.primary.borderActive
        },
        ...commonStyles
      };
  }
});

export const TextareaAutosize = React.forwardRef<
  HTMLTextAreaElement,
  TextareaAutosizeProps
>(function TextareaAutosize(props, ref) {
  return <TextareaAutosizeRoot {...props} ref={ref} />;
});
